import { render } from "./ThePriceLabel.vue?vue&type=template&id=12963cd1&scoped=true&ts=true"
import script from "./ThePriceLabel.vue?vue&type=script&lang=ts"
export * from "./ThePriceLabel.vue?vue&type=script&lang=ts"

import "./ThePriceLabel.vue?vue&type=style&index=0&id=12963cd1&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12963cd1"]])

export default __exports__